import { render, staticRenderFns } from "./ProductEditLabelList.vue?vue&type=template&id=1e005876&scoped=true&"
import script from "./ProductEditLabelList.vue?vue&type=script&lang=js&"
export * from "./ProductEditLabelList.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditLabelList.vue?vue&type=style&index=0&id=1e005876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e005876",
  null
  
)

export default component.exports